import { render, staticRenderFns } from "./loginContent.vue?vue&type=template&id=4565de72&scoped=true&"
import script from "./loginContent.vue?vue&type=script&lang=js&"
export * from "./loginContent.vue?vue&type=script&lang=js&"
import style0 from "./loginContent.vue?vue&type=style&index=0&id=4565de72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565de72",
  null
  
)

export default component.exports